module.exports = __webpack_public_path__ + "static/img/陈晓东 (2).61ffa1fa.png";